var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import MapLocation from "../base/MapLocation";
import { v4 } from "uuid";
var SearchBox = /** @class */ (function () {
    function SearchBox(input, select, btn, autocompleteContainer, startingLocation, callback) {
        this.lastRadius = 0;
        this.isSuggestion = false;
        this.accessToken = atob("cGsuZXlKMUlqb2lZV2RwYkdsemNtVm5aVzV6WW5WeVp5SXNJbUVpT2lKamJHd3lNM293ZGpFd2VUUTVNMlJ4Y21SaGRIRnNiSEkwSW4wLmJ5V1k1QTM4d2pjNEpRa1BRNlBVQkE=");
        this.input = input;
        this.select = select;
        this.btn = btn;
        this.autocompleteContainer = autocompleteContainer;
        this.callback = callback;
        this.lastLocation = startingLocation;
        input.addEventListener("input", this.onInput.bind(this));
        btn.addEventListener("click", this.onClick.bind(this));
        select.addEventListener("change", this.onSelectChange.bind(this));
        var sessionToken = localStorage.getItem("map_session_token");
        if (sessionToken == null) {
            this.sessionToken = v4();
            localStorage.setItem("map_session_token", this.sessionToken);
        }
        else {
            this.sessionToken = sessionToken;
        }
    }
    SearchBox.prototype.reset = function () {
        this.input.value = "";
        this.select.selectedIndex = 0;
        this.clearSuggestions();
    };
    SearchBox.prototype.onInput = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var resultPromise, result, value, selectedOption;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(event instanceof InputEvent)) return [3 /*break*/, 2];
                        resultPromise = this.queryGeocodingApi();
                        this.isSuggestion = false;
                        this.clearSuggestions();
                        return [4 /*yield*/, resultPromise];
                    case 1:
                        result = _a.sent();
                        result.features
                            .sort(function (a, b) { return a.relevance - b.relevance; })
                            .forEach(function (feature) {
                            var element = document.createElement("option");
                            element.value = feature.text;
                            element.dataset.id = feature.id;
                            element.dataset.lat = feature.center[1].toString();
                            element.dataset.lon = feature.center[0].toString();
                            _this.autocompleteContainer.appendChild(element);
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        value = this.input.value;
                        selectedOption = this.autocompleteContainer.querySelector("option[value=\"".concat(value, "\"]"));
                        if (!selectedOption)
                            return [2 /*return*/];
                        this.isSuggestion = true;
                        this.clearSuggestions();
                        this.lastLocation = new MapLocation(-1, parseFloat(selectedOption.dataset.lat), parseFloat(selectedOption.dataset.lon), value, []);
                        this.callback(this.lastLocation, this.lastRadius);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SearchBox.prototype.onClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, sorted, coords, name_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isSuggestion) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.queryGeocodingApi()];
                    case 1:
                        result = _a.sent();
                        if (result.features.length == 0)
                            return [2 /*return*/];
                        sorted = result.features.sort(function (a, b) { return a.relevance - b.relevance; });
                        coords = sorted[0].center;
                        name_1 = sorted[0].text;
                        this.lastLocation = new MapLocation(-1, coords[1], coords[0], name_1, []);
                        _a.label = 2;
                    case 2:
                        this.callback(this.lastLocation, this.lastRadius);
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchBox.prototype.onSelectChange = function () {
        this.lastRadius = parseInt(this.select.value);
        this.callback(this.lastLocation, this.lastRadius);
    };
    SearchBox.prototype.clearSuggestions = function () {
        while (this.autocompleteContainer.firstChild) {
            this.autocompleteContainer.removeChild(this.autocompleteContainer.lastChild);
        }
    };
    SearchBox.prototype.queryGeocodingApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var query, lang, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.input.value;
                        if (query.length < 1) {
                            return [2 /*return*/, {
                                    type: "FeatureCollection",
                                    features: [],
                                }];
                        }
                        lang = navigator.language.substring(0, 2).toLowerCase();
                        return [4 /*yield*/, fetch("https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(query, ".json?&access_token=").concat(this.accessToken, "&language=").concat(lang, "&country=de&proximity=ip"))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, (_a.sent())];
                }
            });
        });
    };
    SearchBox.prototype.resetLastLocation = function (location) {
        this.lastLocation = location;
    };
    return SearchBox;
}());
export default SearchBox;
